'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  font-family: ', ';\n  font-weight: ', ';\n  font-size: 1rem;\n  color: ', ';\n  cursor: pointer;\n  display: inline;\n  margin-right: 12px;\n  outline: none;\n  padding: 0px;\n  position: relative;\n  white-space: nowrap;\n'], ['\n  font-family: ', ';\n  font-weight: ', ';\n  font-size: 1rem;\n  color: ', ';\n  cursor: pointer;\n  display: inline;\n  margin-right: 12px;\n  outline: none;\n  padding: 0px;\n  position: relative;\n  white-space: nowrap;\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _ButtonMenuBase = require('./ButtonMenuBase');
var _ButtonMenuBase2 = _interopRequireDefault(_ButtonMenuBase);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ButtonMenu = (0, _styledComponents2['default'])(_ButtonMenuBase2['default'])(_templateObject, function (props) {
  return props.theme.fontFamily;
}, function (props) {
  return props.theme.fontWeightMedium;
}, function (props) {
  return props.theme.colorTextModerate;
});
exports['default'] = ButtonMenu;